<div class="footer-wrapper">
  <div>
    <footer class='footer pt-6 pb-2'>
      <div class='container'>
        <div class='row'>

          <div class='col-sm-6 col-md-6 col-lg-3 col-xl-2 mb-4'>
            <h6 i18n="Footer@@header-support">Support</h6>
            <ul>
              <li class="text-nowrap"><i aria-hidden="true" class="ready-check ms-Icon ms-Icon--Globe align-middle"></i> <a href="https://itsm.ri.se/selfservice" target="_blank" i18n="Footer@@self-service">Self service</a></li>
              <li class="text-nowrap"><i aria-hidden="true" class="ready-check ms-Icon ms-Icon--Phone align-middle"></i> <a href="tel:+46105165700">+46 10 516 5700</a></li>
              <li class="text-nowrap"><i aria-hidden="true" class="ready-check ms-Icon ms-Icon--Mail align-middle"></i> <a href="mailto:support.it@ri.se">support.it@ri.se</a></li>
            </ul>
          </div>

          <div class='col-sm-6 col-md-6 col-lg-3 col-xl-2 mb-4'>
            <h6 i18n="Footer@@header-instructions">Instructions</h6>
            <ul>
              <li><a href="https://risecloud.sharepoint.com/sites/PDP/SitePages/PDP-Help-page.aspx" target="_blank" i18n="Footer@@guide">Guide</a></li>
              <li><a href="https://risecloud.sharepoint.com/sites/PDP/SitePages/PDP-Help-page.aspx" target="_blank" i18n="Footer@@faq">FAQ</a></li>
              <li><a href="https://risecloud.sharepoint.com/sites/PDP/SitePages/PDP-Help-page.aspx" target="_blank" i18n="Footer@@tutorial">Tutorial videos</a></li>
            </ul>
          </div>

          <div class='col-sm-6 col-md-6 col-lg-3 col-xl-2 mb-4'>
            <h6 i18n="Footer@@header-links">Links</h6>
            <ul>
              <li><a href="https://risecloud.sharepoint.com/sites/PDP/" target="_blank" i18n="Footer@@pdp-information">PDP information site</a></li>
              <li><a href="https://risecloud.sharepoint.com/sites/sakerhet/SitePages/Informationss%C3%A4kerhet.aspx" target="_blank" i18n="Footer@@information-classification-guidelines">Guidelines of Information classification</a></li>
              <li><a href="https://risecloud.sharepoint.com/sites/proj" target="_blank" i18n="Footer@@rise-project-model">Project Lab</a></li>
            </ul>
          </div>

          <div class='col-sm-6 col-md-6 col-lg-3 col-xl-2 mb-4'>
            <h6 i18n="Footer@@header-support-archived">Support - Archived projects</h6>
            <ul>
              <li class="text-nowrap"><i aria-hidden="true" class="ready-check ms-Icon ms-Icon--Globe align-middle"></i> <a href="https://itsm.ri.se/selfservice" target="_blank" i18n="Footer@@self-service">Self service</a></li>
            </ul>
          </div>

          <!--<div class='d-none d-xl-block col-xl-2'>

          </div>-->

          <div class='col-sm-12 col-md-12 col-lg-6 col-xl-4 mb-4'>
            <h6 class='footer-header' i18n="Footer@@header-about-pdp">About the Project Documentation Platform PDP</h6>
            <p i18n="Footer@@about-pdp-text">PDP is used for collaboration and storage of project documentation, for ongoing projects. In PDP you can search för ongoing and archived projects. At the associated project area you archive documentation after project closure.</p>
          </div>

        </div>
      </div>
    </footer>
  </div>
</div>
